export default class CCVBalanceChecker {
    constructor(element) {
        this.root = element
        this.form = this.root.querySelector('form')
        this.info = this.root.querySelector('.ccv-balance-info')
        this.error = this.root.querySelector('.ccv-balance-error')
        this.url = this.form.action

        // Prevent form submission
        this.form.addEventListener('submit', (event) => {
            event.preventDefault()
            this.submit()
        })
    }

    submit() {
        this.showLoader()
        this.hideInfo()
        this.hideError()
        fetch(this.getFullUrl(), {
            headers: {'Content-Type': 'application/json'},
        })
            .then(response => this.handleResponse(response))

    }

    getFullUrl() {
        const action = "ccv_balance_check"
        const ajaxNonce = this.getAjaxNonce()
        const code = this.getCode()
        return `${this.url}?action=${action}&_ajax_nonce=${ajaxNonce}&code=${code}`
    }

    getAjaxNonce() {
        return this.form.querySelector('input[name="_ajax_nonce"]').value
    }

    getCode() {
        return this.form.querySelector('input[name="code"]').value
    }

    handleResponse(response) {
        this.hideLoader()
        if (response.ok === true) {
            response.json().then(data => this.displayInfo(data))
        } else {
            this.displayError()
        }
    }

    processData() {

    }

    displayError() {
        this.showError()
    }

    showError() {
        this.error.classList.remove('hidden')
    }

    hideError() {
        this.error.classList.add('hidden')
    }

    displayInfo(data) {
        this.setExpirationDate(new Date(data.expirationDate))
        //this.setIssueDate(new Date(data.issueDate))
        this.setIssueAmount(data.issueAmount)
        this.setRemainingAmount(data.remainingAmount)
        this.showInfo()
    }

    showInfo() {
        this.info.classList.remove('hidden')
    }

    hideInfo() {
        this.info.classList.add('hidden')
    }

    showLoader() {
        this.root.classList.add('loading')
    }

    hideLoader() {
        this.root.classList.remove('loading')
    }

    setExpirationDate(date) {
        const element = this.info.querySelector('#ccv-balance-expiration-date')
        element.innerHTML = this.formatDate(date)
    }

    setIssueDate(date) {
        const element = this.info.querySelector('#ccv-balance-issue-date')
        element.innerHTML = this.formatDate(date)
    }

    setIssueAmount(amount) {
        const element = this.info.querySelector('#ccv-balance-issue-amount')
        element.innerHTML = this.formatCurrency(amount)
    }

    setRemainingAmount(amount) {
        const element = this.info.querySelector('#ccv-balance-remaining-amount')
        element.innerHTML = this.formatCurrency(amount)
    }

    formatDate(date) {
        return date.toLocaleDateString('nl-BE', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})
    }

    formatCurrency(amount) {
        return `${amount}`
    }
}